import { render, staticRenderFns } from "./previewimg.vue?vue&type=template&id=59f3391c&scoped=true"
import script from "./previewimg.vue?vue&type=script&lang=js"
export * from "./previewimg.vue?vue&type=script&lang=js"
import style0 from "./previewimg.vue?vue&type=style&index=0&id=59f3391c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f3391c",
  null
  
)

export default component.exports